import { IBANItem, IBANStatus } from "../types";

export const convertApiResponseToIBANItem = (apiItem: any): IBANItem => {
  const getStatusFromStatus = (status: number): IBANStatus => {
    switch (status) {
      case 0:
        return IBANStatus.REQUESTED;
      case 1:
        return IBANStatus.IN_PROGRESS;
      case 2:
        return IBANStatus.REJECTED;
      case 3:
        return IBANStatus.APPROVED;
      case 4:
        return IBANStatus.REJECTED;
      default:
        return IBANStatus.REQUESTED;
    }
  };
  return {
    id: apiItem.iban || "",
    title: apiItem.description || "",
    iban: apiItem.iban || "",
    status: getStatusFromStatus(apiItem.requestStatus ?? apiItem.status ?? 0),
    isActiveSettlement: false,
    errorMessage:
      apiItem.requestErrors?.length > 0
        ? apiItem.requestErrors.map((error: any) => `${error.fieldName}: ${error.codeExceptionTitle}`).join(", ")
        : undefined,
  };
};
